import withProps from 'recompose/withProps';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';

import { UNASSIGNED_BARBER } from '../../constants';
import { getActiveBarberId } from '../selectors';
import { getById } from '../../../main/barbers/selector';
import { setActiveBarber } from '../actions';
import OrderInfoItem from '../components/OrderInfoItem';
import { getBarberItems, getFirstBarber } from '../../order/selectors';
import { removeBarber } from '../../order/actions';
import { getSaleSource } from '../../source/selectors';


export default compose(
  connect(
    (state, ownProps) => ({
      barber: getById(state, ownProps.barberId),
      items: getBarberItems(state, ownProps.barberId),
      activeBarberId: getActiveBarberId(state),
      firstBarber: getFirstBarber(state),
      canRemoveBarber: getSaleSource(state) !== 'appointment_product',
    }),
    {
      setActiveBarber,
      removeBarber,
    }
  ),
  withProps(props => ({
    barberId: props.barberId || UNASSIGNED_BARBER,
  })),
  withHandlers({
    setActiveBarber: props => id => () => props.setActiveBarber(id),
    removeBarber: props => id => () => props.removeBarber(id),
  })
)(OrderInfoItem);
